// src/pages/billing/payment/BillingCreatePayment.jsx
import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  TextField,
  MenuItem,
  Button,
  Box,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import api from "../../../utils/api";
import BillingLayout from "../../../layouts/BillingLayout";

const BillingCreatePayment = () => {
  const billingUser = JSON.parse(localStorage.getItem("user"));
  const superAdminId = billingUser?.superAdminId;
  const navigate = useNavigate();

  const [customers, setCustomers] = useState([]);
  const [form, setForm] = useState({
    date: new Date().toISOString().slice(0, 10),
    partyName: "",
    paymentType: "",
    amount: "",
    remarks: "",
  });

  // load customer list
  useEffect(() => {
    async function fetchCustomers() {
      try {
        const res = await api.get(`/api/customers/get-all/${superAdminId}`);
        setCustomers(res.data);
      } catch (err) {
        console.error("Failed to load customers:", err);
      }
    }
    if (superAdminId) fetchCustomers();
  }, [superAdminId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

  const handleSubmit = async () => {
    try {
      await api.post("/api/payments/create", { ...form, superAdminId });
      alert("Payment created successfully!");
      navigate("/billing/payment/view");
    } catch (err) {
      console.error("Error submitting payment:", err);
      alert("Failed to create payment.");
    }
  };

  return (
    <BillingLayout>
      <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
        <Typography variant="h5" gutterBottom>
          Create Payment
        </Typography>
        <Box
          component="form"
          display="flex"
          flexDirection="row"
          flexWrap="wrap"
          alignItems="flex-start"
          gap={2}
          sx={{ width: "100%" }}
        >
          <TextField
            type="date"
            name="date"
            label="Date"
            value={form.date}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            sx={{ minWidth: 160 }}
          />
          <TextField
            select
            name="partyName"
            label="Party Name"
            value={form.partyName}
            onChange={handleChange}
            sx={{ minWidth: 180 }}
          >
            {customers.map((c) => (
              <MenuItem key={c._id} value={c.partyName}>
                {c.partyName}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            select
            name="paymentType"
            label="Payment Type"
            value={form.paymentType}
            onChange={handleChange}
            sx={{ minWidth: 180 }}
          >
            <MenuItem value="Party Payment">Party Payment</MenuItem>
            <MenuItem value="Expense">Expense</MenuItem>
          </TextField>
          <TextField
            type="number"
            name="amount"
            label="Amount"
            value={form.amount}
            onChange={handleChange}
            sx={{ minWidth: 120 }}
          />
          <TextField
            name="remarks"
            label="Remarks"
            value={form.remarks}
            onChange={handleChange}
            multiline
            rows={3}
            sx={{ minWidth: 300 }}
          />
          <Button
            variant="contained"
            onClick={handleSubmit}
            sx={{ height: "fit-content", mt: 1 }}
          >
            Save
          </Button>
        </Box>
      </Container>
    </BillingLayout>
  );
};

export default BillingCreatePayment;
